export default __webpack_public_path__ + "003d0aa679d570587c81c4b7f5faf624.png";